export default {
	props: {
		value: {},
		propData: {},
	},
	data() {
		return {}
	},
	methods: {
		errorCode(title) {
			return this.$createElement('div', {
				domProps: {
					innerHTML: `<h1>${title}</h1>`
				}
			})
		},
	},
	render(h) {
		if (!this.value) {
			return this.errorCode('源码为空！')
		} else {
			const code = this.value

			const templateReg = /<template.*>((?:.|\n)*)<\/template>/
			const templateMatch = templateReg.exec(code)
			if (!templateMatch || !templateMatch[1]) {
				return this.errorCode('template 代码格式不正确！')
			}
			let templateString = templateMatch[1]

			const scriptReg = /<script.*>((?:.|\n)*)<\/script>/
			const scriptMatch = scriptReg.exec(code)
			if (!scriptMatch || !scriptMatch[1]) {
				return this.errorCode('script 代码格式不正确')
			}
			let scriptString = scriptMatch[1]

			const styleReg = /<style.*>((?:.|\n)*)<\/style>/
			const styleMatch = styleReg.exec(code)
			let styleString = !!styleMatch ? styleMatch[1] : null


			const ret = {
				template: templateString.trim(),
				script: scriptString.trim(),
				style: styleString
			}
			ret.script = ret.script.replace('export default', '').trim()

			if (ret.script.charAt(ret.script.length - 1) === ';') {
				ret.script = ret.script.substring(0, ret.script.length - 1)
			}
			const component = eval(`(${ret.script})`)
			component.template = ret.template

			if (!!ret.style) {
				let style = document.querySelector(`#node_${component.name}`)
				if (!!style) {
					style.innerHTML = ret.style
				} else {
					style = document.createElement("style")
					style.setAttribute('id', component.name)
					style.innerHTML = ret.style
					document.head.appendChild(style)
				}
			}

			return h(this.$lv.Vue.extend(component), {props: this.propData})
		}
	},
}
